import '../scss/front-page.scss';